module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ({
        el: '#' + _vm.element,
        container: '#scrollBar',
        duration: 800,
        onDone: _vm.onDone
      }),
      expression: "{\n    el: '#'+element,\n    container: '#scrollBar',\n    duration: 800,\n    onDone: onDone\n    }"
    }],
    class: {
      active: _vm.isActive
    },
    attrs: {
      "href": _vm.to
    },
    on: {
      "click": function($event) {
        _vm.checkEl()
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-235a8852","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/routeItem.vue
// module id = 534
// module chunks = 1